<template>
  <div class="kvass-media-types-vimeo-create">
    <Preview :value="previewValue" :is-valid="validator.passes" />
    <HelpTrigger />
    <InputComponent
      required
      :label="$t('videoLink', { type: 'Vimeo' })"
      v-model="value"
      :validate="validator.isFieldValid('value')"
      :validation-message="validator.getFieldError('value')"
      class="mt-2"
    />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import Preview from './Preview'
import Validator from '../../mixins/validator'

import HelpTrigger from '../../Components/HelpTrigger'
export default {
  mixins: [Validator],

  props: ['upload'],
  watch: {
    'validator.passes': {
      handler(val) {
        this.$emit('update:isValid', val)
      },
    },
  },
  data() {
    return {
      value: null,
      validator: {
        rules: {
          value: 'required|vimeo',
        },
        data: 'dataComp',
        labels: {
          value: this.$t('videoLink', { type: 'Vimeo' }),
        },
      },
    }
  },
  computed: {
    previewValue() {
      return { name: this.value, size: 0, url: this.value, type: 'youtube' }
    },
    dataComp() {
      return {
        value: this.value,
      }
    },
  },
  methods: {
    async prepareData() {
      return { name: this.value, size: 0, url: this.value, type: 'vimeo' }
    },
  },

  components: {
    InputComponent,
    Preview,
    HelpTrigger,
  },
}
</script>
